/**
 * The keyboard half of viewport navigation: Godot's numpad view snaps and
 * projection toggle, plus the WASDQE codes freelook flight reads.
 */
import { viewSnapCursor, OPPOSITE_VIEW, } from './godotEditorCursor.js';
/** Numpad view snaps. Ctrl inverts each to the opposite face. */
const VIEW_SNAP_KEYS = {
    Numpad1: 'front',
    Numpad3: 'right',
    Numpad7: 'top',
};
/** `event.code` → which freelook direction it drives. */
export const FREELOOK_KEYS = {
    KeyW: 'forward',
    KeyS: 'back',
    KeyA: 'left',
    KeyD: 'right',
    KeyQ: 'down',
    KeyE: 'up',
};
/**
 * Consumes a numpad view key, so it scrolls no page: without NumLock the numpad emits
 * End/PageUp/…. Returns whether `event` is one.
 */
export function consumeEditorViewKey(event) {
    const isViewKey = event.code in VIEW_SNAP_KEYS || event.code === 'Numpad5';
    if (isViewKey)
        event.preventDefault();
    return isViewKey;
}
/**
 * Numpad 1/3/7 (+ Ctrl for the opposite face) and Numpad 5. Returns whether the
 * view moved, so the caller owns the single `invalidate()`.
 */
export function applyEditorViewKey(event, handle) {
    if (!consumeEditorViewKey(event))
        return false;
    const view = VIEW_SNAP_KEYS[event.code];
    if (view) {
        handle.applyCursor(viewSnapCursor(handle.cursor(), event.ctrlKey ? OPPOSITE_VIEW[view] : view));
    }
    else {
        handle.toggleProjection();
    }
    return true;
}
/** The directions a set of held key codes asks freelook flight to move in. */
export function freelookKeysFrom(held, sprint) {
    const keys = { sprint };
    for (const code of held) {
        const direction = FREELOOK_KEYS[code];
        if (direction)
            keys[direction] = true;
    }
    return keys;
}
//# sourceMappingURL=editorKeyBindings.js.map